import { Box, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { WHITE } from "../../../../const/colors";
import { getRelativeDay } from "../../../../utils/date";
import { DateTime } from "luxon";

interface AppointmentDateTimeBoxProps {
    isNow: boolean;
    isInTheFuture: boolean;
    startDateTime: DateTime;
}

const useStyles = makeStyles((theme: Theme) => ({
    dateTimeWrapper: (props: { isNow: boolean }) => ({
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexDirection: 'column', 
        backgroundColor: props.isNow
            ? theme.palette.secondary.main
            : theme.palette.grey[300], 
        padding: '8px 16px', 
        minWidth: 110,
        borderRadius: 4
    }),
    dayWrapper: (props: { isNow: boolean }) => ({
        color: props.isNow ? WHITE : '', 
        fontSize: 14
    }),
    timeWrapper: (props: { isNow: boolean, isInTheFuture: boolean }) => ({
        fontSize: 24, 
        fontWeight: 'bold', 
        color: props.isNow
            ? WHITE
            : props.isInTheFuture
            ? theme.palette.secondary.main
            : theme.palette.grey[500]
    }),
    [theme.breakpoints.down('xs')]: {
        dateTimeWrapper: (props: { isNow: boolean }) => ({
            flexDirection: 'row',
            padding: '8px 16px',
            justifyContent: 'space-between',
        }),
        dayWrapper: (props: { isNow: boolean }) => ({
            fontSize: 16
        }),
        timeWrapper: (props: { isNow: boolean, isInTheFuture: boolean }) => ({
            fontSize: 16, 
        })
    }
}));



export const AppointmentDateTimeBox = ({ isNow, isInTheFuture, startDateTime } : AppointmentDateTimeBoxProps) => {
    const classes = useStyles({ isNow, isInTheFuture });
    return (
        <Box className={classes.dateTimeWrapper}>
            <span className={classes.dayWrapper}>
                {getRelativeDay(startDateTime).toUpperCase()}
            </span>
            <span className={classes.timeWrapper}>
                {startDateTime.toFormat('t')}
            </span>
        </Box>
    )
}

export default AppointmentDateTimeBox;